import { CampaignRouletteStatus } from '@/@types/campaign-roulette';

export const CAMPAIGN_STATUS_VALUES = Object.values(CampaignRouletteStatus);

export const BACKEND_STATUS_VALUES = [
  'ACTIVE',
  'INACTIVE', 
  'SCHEDULED',
  'FINISHED'
] as const;

export const FILTER_STATUS_VALUES = [
  'ALL',
  ''
] as const;

export type AllowedStatusValue = 
  | CampaignRouletteStatus 
  | typeof BACKEND_STATUS_VALUES[number]
  | typeof FILTER_STATUS_VALUES[number];

export const ALL_STATUS_VALUES: readonly (string | CampaignRouletteStatus)[] = [
  ...CAMPAIGN_STATUS_VALUES,
  ...BACKEND_STATUS_VALUES,
  ...FILTER_STATUS_VALUES
] as const;
